import { Injectable } from '@angular/core';
import { Logger } from '@myia/ngx-core';
import { BackendService } from '@myia/ngx-http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IEventHistoryList } from '../entities/eventHistoryList.interface';

@Injectable({ providedIn: 'root' })
export class EventHistoryService {

    constructor(private _backendService: BackendService, private _logger: Logger) {
    }

    getEventHistory(culture: string): Observable<IEventHistoryList> {
        return this._backendService.get<IEventHistoryList>(`/events/history?lang=${culture}`)
            .pipe(
                // map(r => { // test 'no events' state
                //     r.events = [];
                //     return r;
                // }),
                catchError(err => {
                    this._logger.error('Could not load event history.');
                    return throwError(err);
                })
            );
    }
}
